module.exports = __webpack_public_path__ + "img/task-4.0bdae010.png";